import React from "react";
import PropTypes from "prop-types";

const getMandatoryField = (man) => {
  if (man) {
    return <span className="text-red-600"> *</span>;
  }
};
const getFieldError = (error) => {
  if (error) {
    return <span className="text-red-600"> {error} </span>;
  }
};
const NumberInput = (props) => {
  const mandatoryField = getMandatoryField(props.mandatory);
  const fieldError = getFieldError(props.error);
  return (
    <>
      <label className="font-medium text-gray-600 block text-sm">
        {props.label}
        {mandatoryField}
        {fieldError}
      </label>
      <input
        onChange={(e) => props.handleValues(props.keyVal, e.target.value)}
        value={props.value}
        type="number"
        disabled={props?.disabled ? props?.disabled : false}
        min="0"
        onInput={(e) => {
          e.target.value =
            !!e.target.value && Math.abs(e.target.value) >= 0
              ? Math.abs(e.target.value)
              : null;
        }}
        className="text-input-color text-16px border border-grey-600 focus:ring-indigo-500 outline-none focus:border-indigo-500 block w-full border-gray-300 rounded-sm p-2"
      />
    </>
  );
};

NumberInput.propTypes = {
  mandatory: PropTypes.bool,
  error: PropTypes.string,
  handleValues: PropTypes.func,
  placeHolder: PropTypes.string,
  label: PropTypes.string,
  keyVal: PropTypes.string,
  value: PropTypes.string,
};

export default NumberInput;
